/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.ready(() => App.message_modal_upgrade.init());

App.message_modal_upgrade = {

  init() {
    this.serious_overage_message = "Sending this message will upgrade your plan and bill you immediately.";

    $(document)
      .off('click', '.js-upgrade-and-send-link', App.message_modal_upgrade.submit_form)
      .on('click', '.js-upgrade-and-send-link', App.message_modal_upgrade.submit_form);
    $(document)
      .off('click', '.js-message-modal-cancel-upgrade', App.message_modal_upgrade.reset_upgrade)
      .on('click', '.js-message-modal-cancel-upgrade', App.message_modal_upgrade.reset_upgrade);
    return $(document)
      .off('click', '.js-reopen-mm', App.message_modal_upgrade.reopen_messaging_modal)
      .on('click', '.js-reopen-mm', App.message_modal_upgrade.reopen_messaging_modal);
  },

  // what happens here if a superadmin adds credits to an account,
  // but doesn't update the plan credits? Does this still work?
  handle_serious_overage(pending_credits_used) {
    const current_modal = $(".modal-state:checked");
    const overage_limit = current_modal.attr('data-overage-limit');
    const original_overage_message = current_modal.closest(".modal-wrapper").find('.js-message-modal-postscript-warning').text();

    const srsly = (pending_credits_used < 0) && overage_limit &&
            (Math.abs(pending_credits_used) > overage_limit);
    const ps_warning = srsly ? App.message_modal_upgrade.serious_overage_message : original_overage_message;

    $('.js-message-modal-postscript-warning')
      .text(ps_warning)
      .toggleClass('immediate-upgrade-warning', srsly);
    $('.js-message-modal-submit').prop('disabled', srsly);
    $('.js-message-modal-submit').toggleClass('disabled', srsly);
    $('.js-upgrade-link').toggle(!srsly);
    return $('.js-upgrade-and-send-link').toggle(srsly);
  },

  reopen_messaging_modal(evt) {
    App.message_modal_upgrade.reset_upgrade();

    const modal_id = $(evt.target).closest(".modal-state").attr("id");
    return App.modals.show_modal(modal_id);
  },

  reset_upgrade(evt) {
    const modal_id = $(evt.target).closest(".modal-state").attr("id");

    // reset title for replies!
    const text = $(modal_id).hasClass('js-reply-modal') ?
             'Reply to ' + $('.msg-single .name').text()
           :
             "Send a New Message";
    $('.js-message-modal-title').text(text);
    $('.js-message-modal-upgrade-container').remove();
    return $('.js-slideupable').show();
  },

  submit_form() {
    return $(this).closest('.message-modal').find('.js-message-modal-submit').prop('disabled', false).click();
  }
};
